export default "__VITE_PUBLIC_ASSET__5079abf9__"